// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { ResponsivePie } from '@nivo/pie'
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";
import logoEmagrecentro from 'assets/img/emagrecentro.png';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search_Icon from "@material-ui/icons/Search";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { Pie } from "@nivo/pie";
import { Bar } from '@nivo/bar';
import { ThemeProvider, SvgWrapper } from "@nivo/core";
import { BoxLegendSvg } from "@nivo/legends";

import PieChart from "@material-ui/icons/PieChart";
// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import Select from 'react-select';
import { ValidSelect } from "beaktShared/helpers/validselect";


// services
import { validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { TableFooter } from '@material-ui/core';
const DataAtual = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear() + ' - ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds();

const useStyles = makeStyles(styles);
export default function RelatorioVendaByCanalMidia() {

    // Padrão para Todas as Telas
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });

    // Elementos de LayOut
    const classes = useStyles();
    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    // Filtros padrão
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    //Filtros para Matriz
    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);

    useEffect(() => {
        verifyAcess();
    }, []);

    const verifyAcess = () => {
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setlistSelectEstabelecimentosSelected([{ estabelecimentoId: session.estabelecimentoId }]);
            setshowSelectEstabelecimentos(false)
        }
    }

    //carrega estabelecimentos
    const LoadEstabelecimentos = () => {
        setloadingSelectEstabelecimentos(true);
        let endPointE = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPointE).then(result => {
            if (result.status !== 200) {
                showNotification(t(' .could_not_load_establishments') + "!", 'danger');
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            setlistSelectEstabelecimentos(result.data);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }

    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
    }

    const handleClickSelecionarTodosEstabelecimentos = () => {

        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() +
            (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }

    // Ações 
    const handleClickPesquisa = () => {
        let data = getValues();

        if (data.dtini === "") {
            setError("dtini", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")

        if (data.dtfim === "") {
            setError("dtfim", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")

        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")

        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);

        if (monthDiff(dataIniConvertida, dataFimConvertida) > 1) {
            showNotification(t('error_message.select_3month'), 'danger')
            return false;
        }

        let obj = {
            dataIni: dataIniConvertida,
            dataFim: dataFimConvertida,
            estabelecimentos: listSelectEstabelecimentosSelected,
        }
        loadDados(obj);
        // loadDadosTotalizador(obj);

    };

    // VENDAS POR ATENTENDE

    // *******************************************************************************
    // ********************************* LOAD LISTA **********************************
    // *******************************************************************************

    const StyledTableCell = withStyles((theme) => ({
        head: {
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }))(TableRow);

    function createData(
        clinica, dtcontrato, contrato, statusContrato, avaliacao,
        cliente, cpf, celular, atendente, usuarioCadastro, qtdPacote, valorPacote, qtdServico,
        valorServico, qtdProduto, valorProduto, boleto, cheque, cartao, ura,
        link, dinheiro, financeira, transferencia, pix, pagoLivre, outros,
        metodo4F, afins, movimento) {
        return {
            clinica, dtcontrato, contrato, statusContrato, avaliacao, cliente,
            cpf, celular, atendente, usuarioCadastro, qtdPacote, valorPacote, qtdServico,
            valorServico, qtdProduto, valorProduto, boleto, cheque, cartao, link, ura,
            dinheiro, financeira, transferencia, pix, pagoLivre, outros, metodo4F, afins, movimento
        };
    }

    const [ValorTotal, set_ValorTotal] = React.useState("");
    const [TotalDinheiro, set_TotalDinheiro] = React.useState("");
    const [TotalFinanceira, set_TotalFinanceira] = React.useState("");
    const [TotalTransferencia, set_TotalTransferencia] = React.useState("");
    const [TotalPix, set_TotalPix] = React.useState("");
    const [TotalPagoLivre, set_TotalPagoLivre] = React.useState("");
    const [TotalOutros, set_TotalOutros] = React.useState("");
    const [TotalMetodo4F, set_TotalMetodo4F] = React.useState("");
    const [TotalCheque, set_TotalCheque] = React.useState("");
    const [TotalCartao, set_TotalCartao] = React.useState("");
    const [TotalLink, set_TotalLink] = React.useState("");
    const [TotalUra, set_TotalUra] = React.useState("");
    const [TotalBoleto, set_TotalBoleto] = React.useState("");
    const [TotalAfins, set_TotalAfins] = React.useState("");
    const [TotalProdutos, set_TotalProdutos] = React.useState("");
    const [TotalProcedimentos, set_TotalProcedimentos] = React.useState("");
    const [TotalTratamentos, set_TotalTratamentos] = React.useState("");
    const [QtdProdutos, set_QtdProdutos] = React.useState("");
    const [QtdProcedimentos, set_QtdProcedimentos] = React.useState("");
    const [QtdTratamentos, set_QtdTratamentos] = React.useState("");
    const [QtdTotal, set_QtdTotal] = React.useState("");


    // *******************************************************************************
    // *********************************** GRAFICO ***********************************
    // *******************************************************************************
    const chartValue = [
        {
            id: t('dashboard.products'),
            label: t('dashboard.products'),
            value: ((TotalProdutos / ValorTotal) * 100).toFixed(2),
            color: "rgb(29, 111, 168)"
        },
        {
            id: t('label.services'),
            label: t('label.services'),
            value: ((TotalProcedimentos / ValorTotal) * 100).toFixed(2),
            color: "rgb(255, 127, 14)"
        },

        {
            id: t('label.packages'),
            label: t('label.packages'),
            value: ((TotalTratamentos / ValorTotal) * 100).toFixed(2),
            color: "rgb(41, 149, 41)"
        }

    ];

    const chartContratos = [
        {
            id: t('dashboard.products'),
            label: t('dashboard.products'),
            value: ((QtdProdutos / QtdTotal) * 100).toFixed(2),
            color: "rgb(29, 111, 168)"
        },
        {
            id: t('label.services'),
            label: t('label.services'),
            value: ((QtdProcedimentos / QtdTotal) * 100).toFixed(2),
            color: "rgb(255, 127, 14)"
        },
        {
            id: t('label.packages'),
            label: t('label.packages'),
            value: ((QtdTratamentos / QtdTotal) * 100).toFixed(2),
            color: "rgb(41, 149, 41)"
        }

    ];

    const chartTotal = [
        {
            id: t('sale.money'),
            label: t('sale.money'),
            value: ((TotalDinheiro / ValorTotal) * 100).toFixed(2),
            color: "rgb(155, 192, 211)"
        },
        {
            id: t('sale.finance'),
            label: t('sale.finance'),
            value: ((TotalFinanceira / ValorTotal) * 100).toFixed(2),
            color: "rgb(29, 112, 168)"
        },
        {
            id: t('label.transfer'),
            label: t('label.transfer'),
            value: ((TotalTransferencia / ValorTotal) * 100).toFixed(2),
            color: "rgb(166, 208, 128)"
        },
        {
            id: t('label.pix'),
            label: t('label.pix'),
            value: ((TotalPix / ValorTotal) * 100).toFixed(2),
            color: "rgb(242, 46, 235)"
        },
        {
            id: t('sale.pago_livre'),
            label: t('sale.pago_livre'),
            value: ((TotalPagoLivre / ValorTotal) * 100).toFixed(2),
            color: "rgb(234, 143, 142)"
        },
        {
            id: t('sale.others'),
            label: t('sale.others'),
            value: ((TotalOutros / ValorTotal) * 100).toFixed(2),
            color: "rgb(211, 24, 26)"
        },
        {
            id: t('sale.metodo4F'),
            label: t('sale.metodo4F'),
            value: ((TotalMetodo4F / ValorTotal) * 100).toFixed(2),
            color: "rgb(236, 178, 103)"
        },
        {
            id: t('sale.check'),
            label: t('sale.check'),
            value: ((TotalCheque / ValorTotal) * 100).toFixed(2),
            color: "rgb(237, 118, 0)"
        },
        {
            id: t('label.billet'),
            label: t('label.billet'),
            value: ((TotalBoleto / ValorTotal) * 100).toFixed(2),
            color: "rgb(188, 166, 199)"
        },
        {
            id: t('sale.card'),
            label: t('sale.card'),
            value: ((TotalCartao / ValorTotal) * 100).toFixed(2),
            color: "rgb(47, 149, 41)"
        },
        {
            id: t('sale.esitefLink'),
            label: t('sale.esitefLink'),
            value: ((TotalLink / ValorTotal) * 100).toFixed(2),
            color: "rgb(237, 237, 142)"
        },
        {
            id: t('sale.ura'),
            label: t('sale.ura'),
            value: ((TotalUra / ValorTotal) * 100).toFixed(2),
            color: "rgb(165, 83, 37)"
        },
        {
            id: t('sale.afins'),
            label: t('sale.afins'),
            value: ((TotalAfins / ValorTotal) * 100).toFixed(2),
            color: "rgb(236, 255, 47)"
        },
    ];


    // *******************************************************************************
    // *************************** PROPRIEDADES CABEÇALHO ****************************
    // *******************************************************************************

    const columns = [{
        id: 'clinica',
        displayName: "Clinica"
    }, {
        id: 'data',
        displayName: "Data"
    },
    {
        id: 'contrato',
        displayName: "Contrato"
    },
    {
        id: 'statusContrato',
        displayName: "Status"
    },
    {
        id: 'avaliacao',
        displayName: "Avaliação"
    },
    {
        id: 'cliente',
        displayName: "Cliente"
    },
    {
        id: 'cpf',
        displayName: "Cpf"
    },
    {
        id: 'celular',
        displayName: "Celular"
    },
    {
        id: 'atendente',
        displayName: "Atendente"
    },
    {
        id: 'usuarioCadastro',
        displayName: "Usuário cadastro"
    },
    {
        id: 'qtdPacote',
        displayName: "Quantidade Pacote"
    },
    {
        id: 'valorPacote',
        displayName: "Pacote"
    },
    {
        id: 'qtdServico',
        displayName: "Quantidade Serviço"
    },
    {
        id: 'valorServico',
        displayName: "Serviço"
    },
    {
        id: 'qtdProduto',
        displayName: "Quantidade Produto"
    },
    {
        id: 'valorProduto',
        displayName: "Produto"
    },
    {
        id: 'boleto',
        displayName: "Boleto"
    },
    {
        id: 'cheque',
        displayName: "Cheque"
    },
    {
        id: 'cartao',
        displayName: "Cartão"
    },
    {
        id: 'ura',
        displayName: "Ura"
    },
    {
        id: 'link',
        displayName: "Esitef-Link"
    },
    {
        id: 'dinheiro',
        displayName: "Dinheiro"
    },
    {
        id: 'financeira',
        displayName: "Financeira"
    },
    {
        id: 'transferencia',
        displayName: "Transferencia"
    },
    {
        id: 'pix',
        displayName: "Pix"
    },
    {
        id: 'pagoLivre',
        displayName: "PagoLivre"
    },
    {
        id: 'outros',
        displayName: "Outros"
    },
    {
        id: 'metodo4F',
        displayName: "Metodo4F"
    },
    {
        id: 'afins',
        displayName: "Cartão Afins"
    },
    {
        id: 'movimento',
        displayName: "Movimento"
    }
    ];

    // *******************************************************************************
    // ************************ CARREGAR ITENS DA LISTA ******************************
    // *******************************************************************************

    const [isLoading, setisLoading] = React.useState(false);
    const [telaAtiva, set_telaAtiva] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const [dataCSV, set_dataCSV] = React.useState([]);

    const loadDados = (obj) => {

        set_telaAtiva(false);
        setisLoading(true);

        const endPoint = "relatorios/reldetalhamentocontrato/";
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoading(false);
                return false;
            }

            setlist(result.data);

            let _dataCSV = [];

            result.data.map(item => {
                var obj = {
                    clinica: item.estabelecimentoDescricao,
                    data: item.dtContrato == null ? "" : formateDate(item.dtContrato),
                    contrato: item.contrato,
                    statusContrato: item.statusContrato,
                    avaliacao: item.dtAvaliacao == null ? "" : formateDate(item.dtAvaliacao),
                    cliente: item.cliente,
                    cpf: item.cpf,
                    celular: item.celular,
                    atendente: item.atendente,
                    usuarioCadastro: item.usuarioCadastro,
                    qtdPacote: item.qtdPacote == null ? "" : item.qtdPacote,
                    valorPacote: 'R$ ' + (item.valorPacote).toFixed(2).replace('.', ','),
                    qtdServico: item.qtdServico == null ? "" : item.qtdServico,
                    valorServico: 'R$ ' + (item.valorServico).toFixed(2).replace('.', ','),
                    qtdProduto: item.qtdProduto == null ? "" : item.qtdProduto,
                    valorProduto: 'R$ ' + (item.valorProduto).toFixed(2).replace('.', ','),
                    boleto: 'R$ ' + (item.boleto).toFixed(2).replace('.', ','),
                    cheque: 'R$ ' + (item.cheque).toFixed(2).replace('.', ','),
                    cartao: 'R$ ' + (item.cartao).toFixed(2).replace('.', ','),
                    link: 'R$ ' + (item.link).toFixed(2).replace('.', ','),
                    ura: 'R$ ' + (item.ura).toFixed(2).replace('.', ','),
                    dinheiro: 'R$ ' + (item.dinheiro).toFixed(2).replace('.', ','),
                    financeira: 'R$' + (item.financeira).toFixed(2).replace('.', ','),
                    transferencia: 'R$' + (item.transferencia).toFixed(2).replace('.', ','),
                    pix: 'R$' + (item.pix).toFixed(2).replace('.', ','),
                    pagoLivre: 'R$' + (item.pagoLivre).toFixed(2).replace('.', ','),
                    outros: 'R$' + (item.outros).toFixed(2).replace('.', ','),
                    metodo4F: 'R$' + (item.metodo4F).toFixed(2).replace('.', ','),
                    afins: 'R$' + (item.afins).toFixed(2).replace('.', ','),
                    movimento: 'R$' + (item.dinheiro + item.cartao + item.link + item.ura + item.boleto + item.cheque + item.financeira + item.transferencia + item.pix + item.pagoLivre + item.outros + item.metodo4F + item.afins).toFixed(2).replace('.', ',')
                };

                _dataCSV.push(obj);
            });

            setTimeout(() => { set_dataCSV(_dataCSV); }, (1000));

            set_ValorTotal(result.data.reduce((a, c) => a = a + c.boleto + c.cheque + c.cartao + c.link + c.ura + c.dinheiro + c.financeira + c.transferencia + c.pix + c.pagoLivre + c.outros + c.metodo4F + c.afins, 0).toFixed(2));
            set_TotalDinheiro(result.data.reduce((a, c) => a = a + c.dinheiro, 0).toFixed(2));
            set_TotalFinanceira(result.data.reduce((a, c) => a = a + c.financeira, 0).toFixed(2));
            set_TotalTransferencia(result.data.reduce((a, c) => a = a + c.transferencia, 0).toFixed(2));
            set_TotalPix(result.data.reduce((a, c) => a = a + c.pix, 0).toFixed(2));
            set_TotalPagoLivre(result.data.reduce((a, c) => a = a + c.pagoLivre, 0).toFixed(2));
            set_TotalOutros(result.data.reduce((a, c) => a = a + c.outros, 0).toFixed(2));
            set_TotalMetodo4F(result.data.reduce((a, c) => a = a + c.metodo4F, 0).toFixed(2));
            set_TotalCheque(result.data.reduce((a, c) => a = a + c.cheque, 0).toFixed(2));
            set_TotalCartao(result.data.reduce((a, c) => a = a + c.cartao, 0).toFixed(2));
            set_TotalLink(result.data.reduce((a, c) => a = a + c.link, 0).toFixed(2));
            set_TotalUra(result.data.reduce((a, c) => a = a + c.ura, 0).toFixed(2));
            set_TotalBoleto(result.data.reduce((a, c) => a = a + c.boleto, 0).toFixed(2));
            set_TotalAfins(result.data.reduce((a, c) => a = a + c.afins, 0).toFixed(2));
            set_TotalProdutos(result.data.reduce((a, c) => a = a + c.valorProduto, 0).toFixed(2));
            set_TotalProcedimentos(result.data.reduce((a, c) => a = a + c.valorServico, 0).toFixed(2));
            set_TotalTratamentos(result.data.reduce((a, c) => a = a + c.valorPacote, 0).toFixed(2));
            set_QtdProdutos(result.data.reduce((a, c) => a = a + c.qtdProduto, 0));
            set_QtdProcedimentos(result.data.reduce((a, c) => a = a + c.qtdServico, 0));
            set_QtdTratamentos(result.data.reduce((a, c) => a = a + c.qtdPacote, 0));
            set_QtdTotal(result.data.reduce((a, c) => a = a + c.qtdPacote + c.qtdServico + c.qtdProduto, 0));

            set_telaAtiva(true);
            setisLoading(false);

            return true;
        });
    }

    //CSV Detalhado Dados Cliente
    const columnsDetalhadoDadosCliente = [{
        id: 'clinica',
        displayName: "Clinica"
    },
    {
        id: 'data',
        displayName: "Data"
    },
    {
        id: 'contrato',
        displayName: "Contrato"
    },
    {
        id: 'statusContrato',
        displayName: "Status"
    },
    {
        id: 'avaliacao',
        displayName: "Avaliação"
    },
    {
        id: 'cliente',
        displayName: "Cliente"
    },
    {
        id: 'cpf',
        displayName: "Cpf"
    },
    {
        id: 'celular',
        displayName: "Celular"
    },
    {
        id: 'rg',
        displayName: "RG"
    },
    {
        id: 'sexo',
        displayName: "Sexo"
    },
    {
        id: 'dataNascimento',
        displayName: "Data Nascimento"
    },
    {
        id: 'email',
        displayName: "Email"
    },
    {
        id: 'ativo',
        displayName: "Ativo no Sistema"
    },
    {
        id: 'facebook',
        displayName: "Facebook"
    },
    {
        id: 'instagram',
        displayName: "Instagram"
    },
    {
        id: 'cep',
        displayName: "CEP"
    },
    {
        id: 'rua',
        displayName: "Rua"
    },
    {
        id: 'numero',
        displayName: "Número"
    },
    {
        id: 'complemento',
        displayName: "Complemento"
    },
    {
        id: 'bairro',
        displayName: "Bairro"
    },
    {
        id: 'cidade',
        displayName: "Cidade"
    },
    {
        id: 'estado',
        displayName: "Estado"
    },
    {
        id: 'atendente',
        displayName: "Atendente"
    },
    {
        id: 'usuarioCadastro',
        displayName: "Usuário cadastro"
    },
    {
        id: 'tipo',
        displayName: 'Tipo'
    },
    {
        id: 'descricao',
        displayName: 'Descrição'
    },
    {
        id: 'quantidade',
        displayName: 'Quantidade'
    },
    {
        id: 'valorUnitario',
        displayName: 'Valor Unitário'
    },
    {
        id: 'valorDesconto',
        displayName: 'Valor Desconto'
    },
    {
        id: 'valorTotal',
        displayName: 'Valor Total'
    },
    {
        id: 'boleto',
        displayName: "Boleto"
    },
    {
        id: 'cheque',
        displayName: "Cheque"
    },
    {
        id: 'cartao',
        displayName: "Cartão"
    },
    {
        id: 'ura',
        displayName: "Ura"
    },
    {
        id: 'link',
        displayName: "Esitef-Link"
    },
    {
        id: 'dinheiro',
        displayName: "Dinheiro"
    },
    {
        id: 'financeira',
        displayName: "Financeira"
    },
    {
        id: 'transferencia',
        displayName: "Transferencia"
    },
    {
        id: 'pix',
        displayName: "Pix"
    },
    {
        id: 'pagoLivre',
        displayName: "PagoLivre"
    },
    {
        id: 'outros',
        displayName: "Outros"
    },
    {
        id: 'metodo4F',
        displayName: "Metodo4F"
    },
    {
        id: 'afins',
        displayName: "Cartão Afins"
    },
    {
        id: 'movimento',
        displayName: "Movimento"
    }
    ];

    const loadDadosDetalhadoDadosCliente = async (obj) => {
        try {
            setisLoadingCSV(true);
            const endPoint = 'relatorios/relcontratogeral/';
            await UsePostApi(endPoint, obj).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setisLoadingCSV(false);
                    return false;
                }
                let _dataCSVDetalhado = [];
                result.data.map(item => {
                    var obj = {
                        clinica: item.estabelecimentoDescricao,
                        data: item.dtContrato == null ? "" : formateDate(item.dtContrato),
                        contrato: item.contrato,
                        statusContrato: item.statusContrato,
                        avaliacao: item.dtAvaliacao == null ? "" : formateDate(item.dtAvaliacao),
                        cliente: item.cliente,
                        cpf: item.cpf,
                        celular: item.celular,
                        rg: item.rg,
                        sexo: item.sexo,
                        dataNascimento: item.dataNascimento == null ? "" : formateDate(item.dataNascimento),
                        email: item.email,
                        ativo: item.ativo,
                        celular: item.celular,
                        facebook: item.facebook,
                        instagram: item.instagram,
                        cep: item.cep,
                        rua: item.rua,
                        numero: item.numero,
                        complemento: item.complemento,
                        bairro: item.bairro,
                        cidade: item.cidade,
                        estado: item.estado,
                        atendente: item.atendente,
                        usuarioCadastro: item.usuarioCadastro,
                        tipo: item.tipo,
                        descricao: item.descricao,
                        quantidade: item.quantidade,
                        valorUnitario: (item.valorUnitario).toFixed(2),
                        valorDesconto: (item.valorDesconto).toFixed(2),
                        valorTotal: (item.valorTotal).toFixed(2),
                        boleto: 'R$ ' + (item.boleto).toFixed(2),
                        cheque: 'R$ ' + (item.cheque).toFixed(2),
                        cartao: 'R$ ' + (item.cartao).toFixed(2),
                        link: 'R$ ' + (item.link).toFixed(2),
                        ura: 'R$ ' + (item.ura).toFixed(2),
                        dinheiro: 'R$ ' + (item.dinheiro).toFixed(2),
                        financeira: 'R$ ' + (item.financeira).toFixed(2),
                        transferencia: 'R$ ' + (item.transferencia).toFixed(2),
                        pix: 'R$ ' + (item.pix).toFixed(2),
                        pagoLivre: 'R$ ' + (item.pagoLivre).toFixed(2),
                        outros: 'R$ ' + (item.outros).toFixed(2),
                        metodo4F: 'R$ ' + (item.metodo4F).toFixed(2),
                        afins: 'R$ ' + (item.afins).toFixed(2),
                        movimento: 'R$ ' + (item.dinheiro + item.cartao + item.link + item.ura + item.boleto + item.cheque + item.financeira + item.transferencia + item.pix + item.pagoLivre + item.outros + item.metodo4F + item.afins).toFixed(2)
                    };
                    _dataCSVDetalhado.push(obj);
                });

                setTimeout(() => { setdataCSVDetalhadoDadosCliente(_dataCSVDetalhado); }, (1000));
                setisLoadingCSV(false);
                setDownloadReady(true);

            });
        }
        catch { }
    }

    const handleClickBuscaDetalhadoDadosCliente = async () => {
        try {
            let data = getValues();
            var dataIniConvertida = convertDate(data.dtini);
            var dataFimConvertida = convertDate(data.dtfim);

            if (monthDiff(dataIniConvertida, dataFimConvertida) > 1) {
                showNotification(t('error_message.select_3month'), 'danger')
                return false;
            }

            let obj = {
                dataIni: dataIniConvertida,
                dataFim: dataFimConvertida,
                estabelecimentos: listSelectEstabelecimentosSelected,
            }

            setNomeArquivo('ContratoDetalhadoDadosCliente_' + data.dtini.replace(/\//g, '') + '_' + data.dtfim.replace(/\//g, ''));

            await loadDadosDetalhadoDadosCliente(obj);
        }
        catch { }
    }


    const columnsDetalhado = [{
        id: 'clinica',
        displayName: "Clinica"
    },
    {
        id: 'data',
        displayName: "Data"
    },
    {
        id: 'contrato',
        displayName: "Contrato"
    },
    {
        id: 'statusContrato',
        displayName: "Status"
    },
    {
        id: 'avaliacao',
        displayName: "Avaliação"
    },
    {
        id: 'cliente',
        displayName: "Cliente"
    },
    {
        id: 'cpf',
        displayName: "Cpf"
    },
    {
        id: 'celular',
        displayName: "Celular"
    },
    {
        id: 'atendente',
        displayName: "Atendente"
    },
    {
        id: 'usuarioCadastro',
        displayName: "Usuário cadastro"
    },
    {
        id: 'tipo',
        displayName: 'Tipo'
    },
    {
        id: 'descricao',
        displayName: 'Descrição'
    },
    {
        id: 'quantidade',
        displayName: 'Quantidade'
    },
    {
        id: 'valorUnitario',
        displayName: 'Valor Unitário'
    },
    {
        id: 'valorDesconto',
        displayName: 'Valor Desconto'
    },
    {
        id: 'valorTotal',
        displayName: 'Valor Total'
    },
    {
        id: 'boleto',
        displayName: "Boleto"
    },
    {
        id: 'cheque',
        displayName: "Cheque"
    },
    {
        id: 'cartao',
        displayName: "Cartão"
    },
    {
        id: 'ura',
        displayName: "Ura"
    },
    {
        id: 'link',
        displayName: "Esitef-Link"
    },
    {
        id: 'dinheiro',
        displayName: "Dinheiro"
    },
    {
        id: 'financeira',
        displayName: "Financeira"
    },
    {
        id: 'transferencia',
        displayName: "Transferencia"
    },
    {
        id: 'pix',
        displayName: "Pix"
    },
    {
        id: 'pagoLivre',
        displayName: "PagoLivre"
    },
    {
        id: 'outros',
        displayName: "Outros"
    },
    {
        id: 'metodo4F',
        displayName: "Metodo4F"
    },
    {
        id: 'afins',
        displayName: "Cartão Afins"
    },
    {
        id: 'movimento',
        displayName: "Movimento"
    }
    ];

    const [nomeArquivo, setNomeArquivo] = React.useState('ContratoDetalhado');
    const [dataCSVDetalhado, setdataCSVDetalhado] = React.useState([]);
    const [dataCSVDetalhadoDadosCliente, setdataCSVDetalhadoDadosCliente] = React.useState([]);
    const [isLoadingCSV, setisLoadingCSV] = React.useState(false);
    const [downloadReady, setDownloadReady] = React.useState(false);
    const csvInstance = React.useRef(null);
    const csvInstanceDadosCliente = React.useRef(null);

    const loadDadosContratoGeral = async (obj) => {
        try {
            setisLoadingCSV(true);
            const endPoint = 'relatorios/relcontratogeral/';
            await UsePostApi(endPoint, obj).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setisLoadingCSV(false);
                    return false;
                }

                let _dataCSVDetalhado = [];
                result.data.map(item => {
                    var obj = {
                        clinica: item.estabelecimentoDescricao,
                        data: item.dtContrato == null ? "" : formateDate(item.dtContrato),
                        contrato: item.contrato,
                        statusContrato: item.statusContrato,
                        avaliacao: item.dtAvaliacao == null ? "" : formateDate(item.dtAvaliacao),
                        cliente: item.cliente,
                        cpf: item.cpf,
                        celular: item.Celular,
                        atendente: item.atendente,
                        usuarioCadastro: item.usuarioCadastro,
                        tipo: item.tipo,
                        descricao: item.descricao,
                        quantidade: item.quantidade,
                        valorUnitario: 'R$ ' + (item.valorUnitario).toFixed(2),
                        valorDesconto: 'R$ ' + (item.valorDesconto).toFixed(2),
                        valorTotal: 'R$ ' + (item.valorTotal).toFixed(2),
                        boleto: 'R$ ' + (item.boleto).toFixed(2),
                        cheque: 'R$ ' + (item.cheque).toFixed(2),
                        cartao: 'R$ ' + (item.cartao).toFixed(2),
                        link: 'R$ ' + (item.link).toFixed(2),
                        ura: 'R$ ' + (item.ura).toFixed(2),
                        dinheiro: 'R$ ' + (item.dinheiro).toFixed(2),
                        financeira: 'R$ ' + (item.financeira).toFixed(2),
                        transferencia: 'R$ ' + (item.transferencia).toFixed(2),
                        pix: 'R$ ' + (item.pix).toFixed(2),
                        pagoLivre: 'R$ ' + (item.pagoLivre).toFixed(2),
                        outros: 'R$ ' + (item.outros).toFixed(2),
                        metodo4F: 'R$ ' + (item.metodo4F).toFixed(2),
                        afins: 'R$ ' + (item.afins).toFixed(2),
                        movimento: 'R$ ' + (item.dinheiro + item.cartao + item.link + item.ura + item.boleto + item.cheque + item.financeira + item.transferencia + item.pix + item.pagoLivre + item.outros + item.metodo4F + item.afins).toFixed(2)
                    };
                    _dataCSVDetalhado.push(obj);
                });

                setTimeout(() => { setdataCSVDetalhado(_dataCSVDetalhado); }, (1000));
                setisLoadingCSV(false);
                setDownloadReady(true);
            });
        }
        catch { }
    }

    const handleClickBuscaContratoGeral = async () => {
        try {
            let data = getValues();
            var dataIniConvertida = convertDate(data.dtini);
            var dataFimConvertida = convertDate(data.dtfim);

            if (monthDiff(dataIniConvertida, dataFimConvertida) > 1) {
                showNotification(t('error_message.select_3month'), 'danger')
                return false;
            }

            let obj = {
                dataIni: dataIniConvertida,
                dataFim: dataFimConvertida,
                estabelecimentos: listSelectEstabelecimentosSelected,
            }

            setNomeArquivo('ContratoDetalhado_' + data.dtini.replace(/\//g, '') + '_' + data.dtfim.replace(/\//g, ''));

            await loadDadosContratoGeral(obj);
        }
        catch { }
    }
    useEffect(() => {
        if (!!dataCSVDetalhado &&
            downloadReady &&
            dataCSVDetalhado.length > 0 &&
            csvInstance &&
            csvInstance.current &&
            csvInstance.current.handleClick) {
            setTimeout(() => {
                csvInstance.current.handleClick();
                setDownloadReady(false);
                setdataCSVDetalhado([]);
            });
        }
    }, [dataCSVDetalhado]);

    useEffect(() => {
        if (!!dataCSVDetalhadoDadosCliente &&
            downloadReady &&
            dataCSVDetalhadoDadosCliente.length > 0 &&
            csvInstanceDadosCliente &&
            csvInstanceDadosCliente.current &&
            csvInstanceDadosCliente.current.handleClick
        ) {
            setTimeout(() => {
                csvInstanceDadosCliente.current.handleClick();
                setDownloadReady(false);
                setdataCSVDetalhadoDadosCliente([]);
            });
        }
    }, [dataCSVDetalhadoDadosCliente]);


    return (

        <div>

            {/* PESQUISA */}
            <GridContainer className="no-print">
                {
                    isLoading &&
                    <div className="carregando">
                        {t('label.loading')}...
                    </div>
                }
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Search_Icon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('label.research')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                {showSelectEstabelecimentos &&
                                    <GridItem xs={12} sm={12} md={12} style={{ zIndex: '999' }}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>
                                                {t('label.establishment')} </label>
                                            <Select
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                style={{ zIndex: '999' }}
                                                placeholder={t('label.select') + "..."}
                                                isMulti={true}
                                                name="estabelecimentos"
                                                isLoading={loadingSelectEstabelecimentos}
                                                options={listSelectEstabelecimentos}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                                onChange={(value) => handleEstabelecimentoChange(value || [])}
                                                ref={() => register({ name: "estabelecimentos" })}
                                            />
                                            {errors.estabelecimentos &&
                                                <FormHelperText>
                                                    <span className="obg"> {t('label.select_an_establishment')} </span>
                                                </FormHelperText>}

                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{ marginTop: '10px' }}>
                                                    {t('label.select_all_establishments')}
                                                </a></div>
                                        </FormControl>
                                    </GridItem>}
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                                            {t('label.ini_date') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtini"
                                            defaultValue={dtini}
                                            value={dtini}
                                            onChange={date => { setdtini(date) }}
                                            inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtini ? "error" : ""}
                                        />
                                        {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtini.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                                            {t('label.end_date') + " *"}  </label>
                                        <Datetime
                                            locale={getLocale()}
                                            dateFormat={getStringFormatDate()}
                                            timeFormat={false}
                                            name="dtfim"
                                            defaultValue={dtfim}
                                            value={dtfim}
                                            onChange={date => { setdtfim(date) }}
                                            inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                                            className={errors.dtfim ? "error" : ""}
                                        />
                                        {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                            <span> {errors.dtfim.message} </span>
                                        </FormHelperText>}
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button type="button" round color="primary"
                                        onClick={e => { handleClickPesquisa() }}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>
                                {notification.show &&
                                    <div>
                                        <br />
                                        <SnackbarContent
                                            message={notification.message}
                                            color={notification.color}
                                            closeNotification={() => setNotification({ show: false })}
                                            close
                                        />
                                    </div>}
                            </GridContainer>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* LISTA VENDA */}

            {
                telaAtiva &&

                <GridContainer>
                    <GridItem lg={4} sm={12}>
                        <Card className="no-print" style={{ minHeight: '565px' }}>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PieChart />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>{t("label.amount")} (%)</h4>
                            </CardHeader>
                            <CardBody>
                                <Pie
                                    width={325}
                                    height={325}
                                    data={chartTotal}
                                    margin={{ left: 90 }}
                                    startAngle={-65}
                                    endAngle={360}
                                    innerRadius={0.5}
                                    //startAngle={-40}
                                    //endAngle={360}
                                    padAngle={0.7}
                                    cornerRadius={3}
                                    colors={(datum) => datum.color}
                                    borderWidth={1}
                                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                                    radialLabelsSkipAngle={1}
                                    radialLabelsTextColor="#333333"
                                    radialLabelsLinkColor={{ from: 'color' }}
                                    sliceLabelsSkipAngle={10}
                                    slicesLabelsTextColor="#000"
                                    radialLabelsLinkOffset={-10}
                                    radialLabelsLinkDiagonalLength={20}
                                    radialLabelsLinkHorizontalLength={10}
                                    radialLabelsLinkStrokeWidth={2}
                                //sliceLabelsSkipAngle={10}
                                />
                                <ThemeProvider>
                                    <SvgWrapper height={195} margin={{ left: 0, right: 0, top: 0, bottom: 0 }}>
                                        <BoxLegendSvg
                                            anchor="right"
                                            data={chartTotal}
                                            direction="column"
                                            itemWidth={120}
                                            itemHeight={10}
                                            itemsSpacing={5}
                                            //itemOpacity={.5}
                                            padding={5}
                                            symbolSize={12}
                                            symbolShape="square"
                                        />
                                    </SvgWrapper>
                                </ThemeProvider>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem lg={4} sm={12} >
                        <Card className="no-print" style={{ minHeight: '565px' }}>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PieChart />
                                </CardIcon>

                                <h4 className={classes.cardIconTitle}>{t('label.total_by_product')} (%)</h4>
                            </CardHeader>
                            <CardBody>
                                <Pie
                                    width={325}
                                    height={325}
                                    data={chartValue}
                                    margin={{ left: 60 }}
                                    startAngle={-65}
                                    endAngle={360}
                                    innerRadius={0.5}
                                    padAngle={0.7}
                                    cornerRadius={3}
                                    colors={{ scheme: 'category10' }}
                                    borderWidth={1}
                                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                                    radialLabelsSkipAngle={1}
                                    radialLabelsTextColor="#333333"
                                    radialLabelsLinkColor={{ from: 'color' }}
                                    sliceLabelsSkipAngle={10}
                                    slicesLabelsTextColor="#fff"
                                    radialLabelsLinkOffset={-10}
                                    radialLabelsLinkDiagonalLength={20}
                                    radialLabelsLinkHorizontalLength={10}
                                    radialLabelsLinkStrokeWidth={2}
                                //sliceLabelsSkipAngle={10}
                                />
                                <ThemeProvider>
                                    <SvgWrapper height={195} margin={{ left: 0, right: 0, top: 0, bottom: 0 }}>
                                        <BoxLegendSvg
                                            anchor="right"
                                            data={chartValue}
                                            direction="column"
                                            itemWidth={120}
                                            itemHeight={10}
                                            itemsSpacing={5}
                                            //itemOpacity={.5}
                                            padding={5}
                                            symbolSize={12}
                                            symbolShape="square"
                                        />
                                    </SvgWrapper>
                                </ThemeProvider>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem lg={4} sm={12}>
                        <Card className="no-print" style={{ minHeight: '565px' }}>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PieChart />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>{t('label.quantity_product')} (%)</h4>
                            </CardHeader>
                            <CardBody>
                                <Pie
                                    width={325}
                                    height={325}
                                    data={chartContratos}
                                    margin={{ left: 80 }}
                                    startAngle={-65}
                                    endAngle={360}
                                    innerRadius={0.5}
                                    padAngle={0.7}
                                    cornerRadius={3}
                                    colors={{ scheme: 'category10' }}
                                    borderWidth={1}
                                    borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                                    radialLabelsSkipAngle={1}
                                    radialLabelsTextColor="#333333"
                                    radialLabelsLinkColor={{ from: 'color' }}
                                    sliceLabelsSkipAngle={1}
                                    slicesLabelsTextColor="#fff"
                                    radialLabelsLinkOffset={-10}
                                    radialLabelsLinkDiagonalLength={20}
                                    radialLabelsLinkHorizontalLength={10}
                                    radialLabelsLinkStrokeWidth={2}
                                //sliceLabelsSkipAngle={10}
                                />
                                <ThemeProvider>
                                    <SvgWrapper height={195} margin={{ left: 0, right: 0, top: 0, bottom: 0 }}>
                                        <BoxLegendSvg
                                            anchor="right"
                                            data={chartContratos}
                                            direction="column"
                                            itemWidth={120}
                                            itemHeight={10}
                                            itemsSpacing={5}
                                            //itemOpacity={.5}
                                            padding={5}
                                            symbolSize={12}
                                            symbolShape="square"
                                        />
                                    </SvgWrapper>
                                </ThemeProvider>
                            </CardBody>
                        </Card>
                    </GridItem>

                    <GridItem md={12} xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('sidebar.resume_contract')}
                                </h4>

                            </CardHeader>

                            <CardBody>
                                {
                                    isLoadingCSV &&
                                    <div className="carregando">
                                        {t('label.loading')}...
                                    </div>
                                }
                                <TableContainer>
                                    {
                                        dataCSV.length > 0 &&
                                        <div className='text-right no-print'>
                                            <div style={{ display: 'inline-flex', gap: '.75rem' }}>
                                                {
                                                    downloadReady && (
                                                        <div style={{ display: 'none' }}>
                                                            <CsvDownloader
                                                                filename={nomeArquivo}
                                                                columns={columnsDetalhadoDadosCliente}
                                                                datas={dataCSVDetalhadoDadosCliente}
                                                                separator={';'}
                                                                ref={csvInstanceDadosCliente}
                                                                handleEmpty={() => void 0}
                                                                isLoading={isLoadingCSV}
                                                            />
                                                        </div>)
                                                }
                                                <Button
                                                    onClick={e => { handleClickBuscaDetalhadoDadosCliente() }}
                                                    round color="default"
                                                    className="no-print">
                                                    CSV Detalhado Dados Cliente
                                                </Button>
                                            </div>
                                            <div style={{ display: 'inline-flex', gap: '.75rem' }}>
                                                {
                                                    downloadReady && (
                                                        <div style={{ display: 'none' }}>
                                                            <CsvDownloader
                                                                filename={nomeArquivo}
                                                                columns={columnsDetalhado}
                                                                datas={dataCSVDetalhado}
                                                                separator={';'}
                                                                ref={csvInstance}
                                                                handleEmpty={() => void 0}
                                                                isLoading={isLoadingCSV}
                                                            />
                                                        </div>)
                                                }
                                                <Button
                                                    onClick={e => { handleClickBuscaContratoGeral() }}
                                                    round color="default"
                                                    className="no-print">
                                                    CSV Detalhado
                                                </Button>
                                                <CsvDownloader filename="Detalhamento" columns={columns} datas={dataCSV} separator={";"}>
                                                    <Button round color="default" className="no-print">CSV</Button>
                                                </CsvDownloader>
                                            </div>
                                        </div>
                                    }

                                    <div className="landscape">
                                        <div className="cabecalho-print">
                                            <div style={{ maxWidth: '200px', display: 'inline-block', float: 'left' }}>
                                                <img src={logoEmagrecentro} style={{ maxWidth: '200px' }} />
                                            </div>
                                            <div style={{ display: 'inline-block', float: 'right' }}>

                                                <p style={{ margin: 0 }}>Filtros: </p>

                                                <h6 style={{ margin: 0 }}>Inicio: {formateDate(dtini)} | Fim: {formateDate(dtfim)} </h6>

                                            </div>
                                        </div>

                                        <hr className="cabecalho-print line" />

                                        <p className="cabecalho-print" style={{ float: "left" }}>Emitido por: {session.nome}  - {DataAtual}</p>
                                    </div>

                                    <Table className={classes.table} aria-label="customized table">

                                        <TableHead className="cabecalho-tabela">

                                            <TableRow style={{ background: 'white' }}>
                                                <StyledTableCell colspan={9}></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell style={{ background: 'rgb(41, 149, 41)', color: 'white' }} colspan={2} class="text-center">{t('label.packages')}</StyledTableCell>
                                                <StyledTableCell style={{ background: 'rgb(255, 127, 14)', color: 'white' }} colspan={2} class="text-center">{t('label.services')}</StyledTableCell>
                                                <StyledTableCell style={{ background: 'rgb(29, 111, 168)', color: 'white' }} colspan={2} class="text-center">{t('dashboard.products')}</StyledTableCell>
                                                <StyledTableCell style={{ background: '#466892', color: 'white' }} colspan={7} class="text-center">{t('label.cash_flow')}</StyledTableCell>

                                            </TableRow>
                                            <TableRow>
                                                <StyledTableCell>{t('label.clinic')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.date')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.contract')}</StyledTableCell>
                                                <StyledTableCell align="center">Status</StyledTableCell>
                                                <StyledTableCell align="center">{t('sidebar.avaliation')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.client')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.cpf')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.cell_phone')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.clerk')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.user_registration')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ borderLeft: 'solid 1px #4d4b8b' }}>{t('label.quantity')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.value')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.quantity')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.value')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.quantity')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.value')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.billet')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.check')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.card')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.ura')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.esitefLink')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.money')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.finance')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.transfer')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.pix')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.pago_livre')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.others')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.metodo4F')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('sale.afins')}</StyledTableCell>
                                                <StyledTableCell align="center">{t('label.movement')}</StyledTableCell>
                                            </TableRow>

                                        </TableHead>

                                        <TableBody>

                                            {list.map((row) => (
                                                <StyledTableRow key={row.estabelecimentoDescricao}>
                                                    <StyledTableCell align="left">{row.estabelecimentoDescricao}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.dtContrato == null ? "" : formateDate(row.dtContrato)}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.contrato}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.statusContrato}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.dtAvaliacao == null ? "" : formateDate(row.dtAvaliacao)}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.cliente}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.cpf}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.celular}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.atendente}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.usuarioCadastro}</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ borderLeft: 'solid 1px #ddd' }}>{row.qtdPacote}</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd' }}>R$ {(row.valorPacote).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center" >{row.qtdServico}</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd' }}>R$ {(row.valorServico).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center" >{row.qtdProduto}</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd' }}>R$ {(row.valorProduto).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.boleto).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.cheque).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.cartao).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.ura).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.link).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.dinheiro).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.financeira).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.transferencia).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.pix).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.pagoLivre).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.outros).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.metodo4F).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.afins).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                    <StyledTableCell align="center">R$ {(row.boleto + row.cheque + row.cartao + row.link + row.ura + row.dinheiro + row.financeira + row.transferencia + row.pix + row.pagoLivre + row.outros + row.metodo4F + row.afins).toFixed(2).replace('.', ',')}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}

                                        </TableBody>

                                        <TableFooter>

                                            <TableRow className="cabecalho-tabela">

                                                <StyledTableCell colspan={10} align="left" style={{ color: 'white', fontSize: '16px' }}>Total</StyledTableCell>

                                                <StyledTableCell align="center" style={{ borderLeft: 'solid 1px #ddd', color: 'white' }}>{QtdTratamentos}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd', color: 'white' }}>R$ {TotalTratamentos.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>{QtdProcedimentos}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd', color: 'white' }}>R$ {TotalProcedimentos.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>{QtdProdutos}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ borderRight: 'solid 1px #ddd', color: 'white' }}>R$ {TotalProdutos.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalBoleto.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalCheque.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalCartao.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalUra.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalLink.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalDinheiro.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalFinanceira.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalTransferencia.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalPix.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalPagoLivre.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalOutros.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalMetodo4F.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {TotalAfins.replace('.', ',')}</StyledTableCell>
                                                <StyledTableCell align="center" style={{ color: 'white' }}>R$ {ValorTotal.replace('.', ',')}</StyledTableCell>

                                            </TableRow>

                                        </TableFooter>

                                    </Table>

                                </TableContainer>

                            </CardBody>

                        </Card>
                    </GridItem>

                </GridContainer>

            }

        </div>

    );

}